import {Alert, Box, Skeleton} from '@mui/material';
import {ReactNode} from 'react';

interface DashboardStateProps {
    isAuthorized: boolean;
    isLoading: boolean;
    isError: boolean;
    cards: number;
    children: () => ReactNode;
}

export const CARD_GRID = {display: 'grid', gridTemplateColumns: {xs: '1fr', md: 'repeat(2, minmax(0, 1fr))'}, gap: 2};

const DashboardState = ({isAuthorized, isLoading, isError, cards, children}: DashboardStateProps) => {
    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    if (isError) {
        return <Alert severity='error'>Errore nel caricamento dei dati. Ricarica la pagina o riprova più tardi.</Alert>;
    }

    return (
        <Box sx={{p: {xs: 1, sm: 2}}}>
            {isLoading ? (
                <Box sx={CARD_GRID} aria-busy='true' aria-label='Caricamento dei grafici'>
                    {Array.from({length: cards}, (_, i) => (
                        <Skeleton key={i} variant='rounded' height={340} sx={{borderRadius: 2.5}} />
                    ))}
                </Box>
            ) : (
                children()
            )}
        </Box>
    );
};

export default DashboardState;
